import {useNavigate} from "react-router-dom";
import {useGetFeaturedCompaniesQuery} from "../../store/services/publicApi";
import {SectionHeader} from "./Shared";

type FeaturedCompany = {
    id: string;
    name: string;
    description: string;
    logo: string;
    location?: string;
    isSupplier?: boolean;
};

export const FeaturedCompanies = () => {
    const {data: Companies = [], isLoading} = useGetFeaturedCompaniesQuery(undefined);

    if (isLoading || !Companies.length) {
        return null;
    }

    return (
        <section className="oec-section oec-section-tint">
            <div className="oec-section-inner">
                <SectionHeader
                    title="Featured Companies"
                    linkLabel="View All Companies"
                    linkTo="/companies"
                />

                <div className="oec-card-grid oec-card-grid-roomy">
                    {Companies.slice(0, 5).map((company: FeaturedCompany) => (
                        <CompanyCard key={company.id} company={company}/>
                    ))}
                </div>
            </div>
        </section>
    );
};

/** Most seeded companies have no description, so fall back to a neutral label. */
const specialtyOf = (company: FeaturedCompany) => {
    const text = (company.description || "").trim();
    if (!text || /^no description/i.test(text)) {
        return company.isSupplier ? "Energy Supplier" : "Energy Company";
    }
    return text;
};

const CompanyCard = ({company}: {company: FeaturedCompany}) => {
    const navigate = useNavigate();

    return (
        <div className="oec-company-card">
            <div className="oec-company-logo">
                {company.logo && !company.logo.includes("company-placeholder")
                    ? <img src={company.logo} alt={company.name} loading="lazy"/>
                    : <span className="oec-company-wordmark">{company.name}</span>}
            </div>

            <p className="oec-company-type">
                <i className="fas fa-industry"/>
                <span>{specialtyOf(company)}</span>
            </p>

            <p className="oec-company-meta">
                <i className="fas fa-map-marker-alt"/>
                <span>{company.location || "Ethiopia"}</span>
                <span className="oec-company-divider">|</span>
                <span>{company.isSupplier ? "Verified Supplier" : "Verified Company"}</span>
            </p>

            <button className="oec-card-btn" onClick={() => navigate(`/company/${company.id}`)}>
                View Profile <i className="fas fa-arrow-right"/>
            </button>
        </div>
    );
};